export default "__VITE_ASSET__D9owux0j__"